Controller = App.loadClass 'core::Angular/Controller'
turfintersect = require('node_modules/turf-intersect')
merge = require('node_modules/turf-merge')
jenks = require('node_modules/turf-jenks')

# Genering controller that handles zone drawing for each of the different
# zone types
class exports.DefineZonesController extends Controller
    constructor: (@scope, @transitions, @zone_type, @pgis, @validation, @undo) ->
        # prevent errors when refreshing or navigating directly to this step
        if @validation.canContinue()
            @initialize()

    initialize: () =>
        @initializeVariables()
        @initializeListeners()
        @setBackButtonDisable()

    setBackButtonDisable: (field_data) =>
        @validation.setBackButtonDisable(@scope.field_data, 'zone-edit')

    initializeVariables: () =>
        @scope.validate = @validate
        @scope.cleanup = @cleanup
        @validation.setStepScope(@scope)
        # set/load field data
        @scope.field_data = @validation.getFieldData()
        # functions
        @scope.deleteZone = @deleteZone
        @scope.selectZone = @selectZone
        @scope.addZone = @addZone
        # variables
        @scope.current_zone = if @scope.current_zone? then @scope.current_zone else null
        @scope.mode = ''
        # don't show sidebar until its loaded
        @scope.loaded = {
            table: false
        }
        @scope.disabled.next = false
        # default opacity
        @opacity = 0.6
        # Set the object we'll use to save our zones
        @scope.zone_object = @scope.field_data.zones[@zone_type]
        # Set up the drawing control and add it to the map
        @ctrl = new L.Control.MfDraw {}
        # set opacity
        @ctrl.setFinishedStyle(@opacity)

        # finish setting variables based on which entry point was hit
        @initializeByProcessMode()
        # add drawing tools to the map
        App.map.addControl(@ctrl)
        # add control to undo service
        @undo.setDrawControl(@ctrl)

        if @zone_type is 'irrigation' and not @isEditing()
            @ctrl.getButton('draw-circle-add').trigger('click')
        else if not @isEditing()
            @ctrl.getButton('draw-poly-add').trigger('click')

        @fillGeom()

    isEditing: () =>
        return @scope.field_data.process_mode is 'zone-edit'

    cleanup: () =>
        delete @scope.field_data
        delete @scope.current_zone
        @undo.cleanup()

    validate: () =>
        @validation.setFieldData(@scope.field_data)

        return true

    noDataNeedsLoaded: () =>
        return (@scope?.zone_object?.zones?.length is 0 and not @scope.zone_object?.loaded_zones?)

    setFromBackButton: () =>
        @scope.loaded.table = true
        count = 0
        for i in @scope.zone_object.zones
            i.settings = []
            i.color = @validation.zones_service.getNextColor(false, count)
            count += 1
            @convertGeoJSON(i.visible.toGeoJSON(), i)

    initializeByProcessMode: () =>
        if @noDataNeedsLoaded()
            if @scope.field_data.visited_settings?
                @scope.loaded.table = true
                @setFromBackButton()
                @selectZone(@scope.zone_object.zones[0])
            else
                @addZone() # If there are no previous zones...
                @scope.loaded.table = true
                # If we loaded any polygons from CLUs / previously drawn boundary,
                # then set those as our local polygon list (for display in the sidebar)
                @scope.polygons = @ctrl.getAreas([], null, 1, @pgis.units)
        else if @scope?.field_data?.process_mode is 'zone-edit'
            if @scope.field_data.visited_settings?
                @scope.loaded.table = true
                @setFromBackButton()
            else
                @pgis.fieldDataGeoJsonToBoundaryLayer(@scope.field_data, true, true)
                @convertSavedZones()
                if not @scope.zone_object.zones[0]?
                    @addZone()
                @selectZone(@scope.zone_object.zones[0])

        else if @scope?.field_data?.process_mode in ['zone-add', 'irrigation-add']
            if @scope.field_data.visited_settings?
                @scope.loaded.table = true
                @setFromBackButton()
            # update an existing irrigation zone if it exists instead of adding a new one
            else if @scope.zone_object.loaded_zones?.length
                @convertSavedZones()
                @scope.loaded.table = true
                @deleteEmptyZones()
                @selectZone(@scope.zone_object.zones[0])

        if not @scope.current_zone
            @selectZone(@scope.zone_object.zones[0])

    deleteEmptyZones: () =>
        # use for recursion to prevent breaking the loop by deleting
        deleted = false
        # if zones layers have no area then they are getting deleted
        for zone, index in @scope.zone_object.zones
            if zone.visible? or zone.geojson?
                if zone.visible?.toGeoJSON()
                    geojson = zone.visible.toGeoJSON()
                else if zone.geojson?
                    geojson = zone.geoJson

                if not (turf.area(geojson) > 0) and @scope.zone_object.zones.length > 1
                    @deleteZone(zone)
                    deleted = true
                    break
            else
                deleted = false
                @deleteZone(zone)
                break

        if deleted
            @deleteEmptyZones()

    validateRings: (feature) =>
        # only multipolygons need validated
        if feature.geometry.type isnt 'MultiPolygon'
            return feature

        validated_rings = []
        oneOneHundrethOfAnAcreInSqMeters = 40.46

        # check the area of each ring and toss the ones that are less than ~1/100 of an acre
        for ring, index in feature.geometry.coordinates
            if turf.area(turf.polygon(ring, {})) > oneOneHundrethOfAnAcreInSqMeters
                validated_rings.push ring

        feature.geometry.coordinates = validated_rings

        return feature

    fillGeom: () =>
        @scope.auto = false
        existing_geoms = []
        # get all existing zone geoms into an array
        for zone in @scope.zone_object.zones
            existing_geoms.push L.GeoUtil.multiPolygonize zone.visible.toGeoJSON()

        # get field boundary geom
        boundary = L.GeoUtil.multiPolygonize @scope.field_data.boundary
        # choose the first zone to start with
        total = existing_geoms[0]
        # merge remaining zones (if they exist)
        for z in existing_geoms when z isnt total and z.geometry.coordinates.length
            # handle geometry collections
            if total.geometry.geometries?
                # pull the valid features from the gemoetry collection
                total = @validation.convertGeometryCollection(total)
                # add the current zone to the list of features to be merged
                total.push z
                # merge features
                total = merge({ type: 'FeatureCollection', features: total })
            else
                z = @validateRings(z)
                total = merge({ type: 'FeatureCollection', features: [z, total] })

            total = @validateRings(total)

        if total and total.geometry?.type?
            # see if there are any gaps in the area coverage
            @pgis.clipAll(boundary, [total], boundary).then (response) =>
                result = response.data.data
                # if we have gaps, then fill the zones
                if result?.geometry?.type?
                    result = @validateRings(result)
                    # add new zone if needed
                    if turf.area(result) >= 0.1
                        @scope.fillgeom = result
                    else
                        @scope.fillgeom = null
                else
                    @scope.fillgeom = null
                    @deleteEmptyZones()

        else
            @scope.fillgeom = null

        @pgis.setFieldData(@scope.field_data)

    # Delete a zone from the zones list
    deleteZone: (zone) =>
        zone?.visible?.clearLayers()
        # delete areas, but don't remove the zone if its the last one.
        if @scope.zone_object.zones.length is 1
            return

        # If it's curr selected zone, select a different zone
        if @scope.current_zone is zone
            ind = @scope.zone_object.zones.indexOf zone
            @selectZone(@scope.zone_object.zones[Math.abs(ind - 1) % @scope.zone_object.zones.length])

        _.remove(@scope.zone_object.zones, zone)
        @fillGeom()

    setDrawOptions: (zone) =>
        @ctrl.options.draw.style =
            'weight': 2
            'color': zone.color
            'fillOpacity': 0.6
        @ctrl.options.finished.style =
            'weight': 2
            'color': zone.color
            'fillOpacity': 0.6

    handleZoneListeners: (zone) =>
        # remove click listener from all other zones and add a new one
        for z in @scope.zone_object.zones
            if z isnt zone
                z.visible.off 'click', @ctrl._polySelected
                z.visible.off 'click', @findByTarget
                z.visible.on 'click', @findByTarget

    setDrawingOptions: (zone) =>
        @ctrl.setLayer zone?.visible #zone.unclipped
        @ctrl.options.draw.style =
            'weight': 2
            'color': '#00ff00'
            fillColor: zone.color
            'fillOpacity': 0.6
        @ctrl.options.finished.style =
            'weight': 5
            'color': '#FFFFFF'
            fillColor: zone.color
            'fillOpacity': 0.6
            dashArray: [10, 8]

    disableTools: () =>
        @ctrl.deselectAllButtons()
        @ctrl.current_tool?.disable()

    selectZone: (zone, needs_applied = false) =>
        @disableTools()
        @handleZoneListeners(zone)
        # set callback in case we have to resolve a promise first
        select = (zone) =>
            # set drawing options based on zone
            @setDrawingOptions(zone)
            # switch active zone
            @scope.current_zone = zone
            # run scope apply if needed
            if needs_applied isnt false
                @scope.$apply()
            # update colors for all zones
            @colorSelectedZone(zone)
            # clear the undo stack
            @undo.cleanup()

        # clip and sanitize everything before switching
        if @scope.current_zone?.visible?.toGeoJson?()
            @finalizeZone(@scope.current_zone.visible.toGeoJSON()).then () =>
                select(zone)
        else
            select(zone)

    finalizeZone: (combined) =>
        collection = []
        # for clipping to boundary
        field = L.GeoUtil.multiPolygonize @scope.field_data.boundary
        # send combined and @scope.zone_object.zones and scope.current_zone
        for zone in @scope.zone_object.zones when zone isnt @scope.current_zone
            collection.push L.GeoUtil.multiPolygonize zone.visible.toGeoJSON()
        # clip drawn zone to all existing zones + crop to field boundary & sanitize geometries
        @pgis.clipAll(combined, collection, field).then (response) =>
            @ctrl._finishDrawing(response.data.data, false, false)

    # Creates a new zone to draw into. Each zone has 2 feature groups:
    #  - the visible one, which is clipped against the field
    #    boundary as well as being clipped by other zones
    #  - the unclipped one, which is the originally drawn shapes.
    #    This is the layer which the drawing control manipulates shapes in
    #
    # NOTE: the 'unclipped' layer isn't being used right now. It was causing
    # lots of issues. So now everything is done against 'visible'
    addZone: () =>
        zone = {
            unique_id: ++@scope.field_data.zone_unique_id
            settings: {}
            visible: new L.FeatureGroup()
            unclipped: new L.FeatureGroup()
            color: @validation.zones_service.getNextColor(_.last(@scope.zone_object.zones)?.color)
            area: () =>
                gj = zone.visible.toGeoJSON()
                if App.is_metric
                    return turf.area(gj) * 0.0001
                else
                    return turf.area(gj) * 0.000247105
        }

        zone.visible.on 'click', (e) =>
            @findByTarget(e)

        @scope.zone_object.zones.push zone
        zone.visible.addTo App.map
        @selectZone zone

    copyArea: (a, b) ->
        for k, v of a
            b[k] = v

        return b

    resetOtherZoneColors: (z, style) =>
        for zone in @scope.zone_object.zones when z isnt zone
            if zone?.visible?
                style.fillColor = zone.color
                style.color = zone.color
                geojson = zone?.visible.toGeoJSON()
                @convertGeoJSON(geojson, zone, style)

    colorSelectedZone: (zone) =>
        # set style
        style = @validation.zones_service.defaultZoneStyle()

        # reset all other zones colors
        @resetOtherZoneColors(zone, style)

        # reset style because we want the default color for the selected polygon
        style = @validation.zones_service.defaultZoneStyle(true, zone.color, 5, true)
        if zone?.visible?
            geojson = zone?.visible.toGeoJSON?()
            @convertGeoJSON(geojson, zone, style)

    convertGeoJSON: (geojson, zone, style = null) =>
        zone.visible.clearLayers()

        if not style?
            style = @validation.zones_service.defaultZoneStyle(zone.color)

        L.geoJson(geojson).eachLayer (l) =>
            # 'set style on l of combined'
            l.setStyle(style ? {})
            # add layer to the front end
            zone.visible.addLayer(l)
            zone.unclipped.addLayer(l)
            @pgis.added_layers.push l

            zone.visible.addTo(App.map)

    convertSavedZones: () =>
        for area, index in @scope.zone_object.loaded_zones
            # set properties
            area.unique_id = ++@scope.field_data.zone_unique_id
            area.settings = {}
            area.visible = new L.FeatureGroup()
            area.unclipped = new L.FeatureGroup()
            area.color = @validation.zones_service.getNextColor(null, index)
            area.identity = area.id

            # translate the geojson to leaflet
            style = @validation.zones_service.defaultZoneStyle(area.color)

            z = @copyArea(area, {})

            # set the leaflet geoms in visible
            L.geoJson(z.geometry).eachLayer (l) =>
                # 'set style on l of combined'
                l.setStyle(style ? {})
                # add layer to the front end
                z.visible.addLayer(l)
                z.unclipped.addLayer(l)
                @pgis.added_layers.push
                z.visible.addTo(App.map)

            # create a new zone object and push it
            z = @validation.zones_service.setZoneArea(z)
            z.extra_info = JSON.parse(z.extra_info) if z?.extra_info?
            z.visible.on 'click', (e) =>
                @findByTarget(e)
            @scope.zone_object.zones.push z

            @selectZone(@scope.zone_object.zones[index])

        @scope.loaded.table = true

    findByTarget: (e, delete_zone = false) =>
        v = e.target
        # find zone by target
        for zone in @scope.zone_object.zones
            if zone?.visible?._leaflet_id is v?._leaflet_id
                if delete_zone
                    @deleteZone(zone)
                else
                    @selectZone(zone, true, true)

    featureCollection: (features) =>
        # make a feature collection using param as features
        return { type: 'FeatureCollection', features: [features] }

    tryMultiPolygonize: (geojson) =>
        if geojson?.features?.length > 0
            return L.GeoUtil.multiPolygonize geojson
        else
            return L.GeoUtil.multiPolygonize @featureCollection(geojson)

    sortFeatureVsCollection: (unknown, result) =>
        # detect feature vs collection and return correct data
        if unknown?.features?
            result = result.concat(unknown.features)
        if unknown?.geometry?
            result.push unknown

        return result

    formatData: (feature1, feature2) =>
        # return a feature collection containing the aggregated features of f1/f2
        result = @sortFeatureVsCollection(feature1, [])

        return { type: 'FeatureCollection', features: @sortFeatureVsCollection(feature2, result) }

    handleCombineDrawnZone: (drawn, previous, collection, field) =>
        # intersect layers, we use this regardless of mode
        intersect = turfintersect(drawn, previous)
        clip = true

        if intersect
            if @ctrl.mode is 'add' or @ctrl.mode is 'union'
                # merge areas
                result = merge(@formatData(previous, drawn))
            else
                # diff areas
                within = turf.pointsWithinPolygon(turf.explode(previous), @featureCollection(drawn))
                if within?.features.length is turf.explode(previous).features.length
                    @ctrl.layer.clearLayers()
                    clip = false
                else
                    result = turf.difference(previous, drawn)
                # result = customturf.difference(drawn, previous)
        else
            if @ctrl.mode is 'add' or @ctrl.mode is 'union'
                # combine areas (slightly different than a merge)
                combine = @formatData(previous, drawn)
                result = L.GeoUtil.multiPolygonize(combine)
            else
                within = turf.pointsWithinPolygon(turf.explode(previous), @featureCollection(drawn))
                if within?.features.length is turf.explode(previous).features.length
                    result = turf.difference(previous, drawn)
                    clip = false
                else
                    result = previous
        if clip
            # cleanse the result of the operation before moving on
            @pgis.cleanse(result).then (response) =>
                # finish process
                @clipAll(response.data.data, collection, field)
        else
            @scope.$apply()

    clipAll: (combined, collection, field) =>
        # ensure that all data is set
        if combined? and collection? and field? and combined?.type?
            # send all data through clipping function
            @pgis.clipAll(combined, collection, field).then (response) =>
                # finish formatting the result
                @ctrl._finishDrawing(response.data.data)
                @scope.fillgeom = null
                @fillGeom()

    validateLayer: (layer) ->
        # ensure that we either have a feature collection with features or a feature with coordinates
        return layer?.features?.length > 0 or layer?.geometry?.coordinates?.length > 0

    validateLayers: (layers) =>
        # ensure each layer contains geometry
        for l in layers
            if not @validateLayer(l)
                return false

        return true

    initializeListeners: () =>
        # update the undo stack
        @ctrl.on 'mfdraw:undo-update', (data) =>
            @undo.update(data.previous)

        # undo
        @ctrl.on 'mfdraw:undo', () =>
            @undo.undo()

        # force update scope, area, and validation
        @scope.$on 'mfdraw:apply', () =>
            @fillGeom()
            @deleteEmptyZones()
            @scope.$apply()

        # event specific to finishing a polygon with polygon tool
        @ctrl.on 'mfdraw:poly-complete', () =>
            @undo.cleanup()
            @validation.validate()

        # event specific to removing a polygon
        @ctrl.on 'mfdraw:poly-removed', () =>
            @undo.updateButtonStatus()
            @validation.validate()
            @scope.$apply()

        # This transform will crop a newly drawn zone against
        # all previous zones and field boundary
        @ctrl.addTransform (type, layer, combined, previous) =>

            # get geojson from layer
            layer = layer.toGeoJSON()
            # previous is a polygon/multipolygon at this point (even if it was a circle before)
            previous = previous.toGeoJSON()
            # collection will be used to store geometry for all other zones
            collection = []
            # get the field boundary geojson for clipping data to it
            field = @tryMultiPolygonize @scope.field_data.boundary

            # iterate zones and push them into the collection
            for zone in @scope.zone_object.zones when zone isnt @scope.current_zone
                collection.push @tryMultiPolygonize zone.visible.toGeoJSON()

            # ensure that we have data for each layer that we want to work with
            if @validateLayers([layer, previous])
                # if previous and layer are both valid then we need to perform operations on them
                @handleCombineDrawnZone(
                    @tryMultiPolygonize(layer),
                    @tryMultiPolygonize(previous),
                    collection,
                    field
                )
            else
                # if only one (or neither) are valid then we perform only the clip operation with the rest of the data
                @clipAll(combined, collection, field)

        # Sets up listeners for changing the displayed
        # 'Mode:' in the sidebar
        @_setModeListeners(@ctrl)
        @scope.auto = true
        @ctrl.on 'mfdraw:shape-added', () =>
            # update the polygon list
            @scope.polygons = @ctrl.getAreas([], null, 1, @pgis.units)
            @validation.validate()

        App.map.on 'click', () =>
            if @ctrl?.current_tool?.h?._markers?.length
                @scope.disabled.next = true
                @undo.enable()
                @scope.$apply()

        @transitionStart = @transitions.onStart {}, ($transition) =>
            # When we leave this step, clean up
            if _.startsWith($transition.to().name, 'grower.fields-define')
                # set flag
                @scope.died_willingly = true
                # delete all of our empty zones
                @deleteEmptyZones()
                # if we have a fill geometry apply it to the map
                if @scope.fillgeom
                    # add a zone if our current zone is not empty
                    if turf.area(@scope.current_zone.visible?.toGeoJSON()) > 0
                        @addZone()
                    # apply the updates to the map
                    @ctrl._finishDrawing(@scope.fillgeom)
                # reset zone colors
                @resetOtherZoneColors(null, @validation.zones_service.defaultZoneStyle())
            # remove current tool
            if @ctrl
                @ctrl.current_tool?.disable()
                @ctrl.current_tool?.h?.disable()

            @undo.cleanup()

        @scope.$on '$destroy', () =>
            if not @scope.died_willingly
                # clear layers
                @validation.clearLayers()
                # clear settings
                @validation.settings = {}

                for zone in @scope.zone_object.zones
                    if zone?.visible?
                        App.map.removeLayer?(zone.visible)
            if @ctrl?
                App.map.removeControl(@ctrl)

            @transitionStart()

        @scope.$parent.steps.once 'switch-from', "grower.fields-define.#{@zone_type}-draw", (data) =>
            if not data.is_forward
                for z in @scope.zone_object.zones
                    z.visible.clearLayers()

                @scope.field_data.visited_settings = null

            @validation.setZones(@scope.zone_object.zones)

    _setModeListeners: (ctrl) =>
        ctrl.addCallback 'draw-poly-add', () =>
            @scope.mode = 'Add Shape'
        ctrl.addCallback 'draw-rect-add', () =>
            @scope.mode = 'Add Rectangle'
        ctrl.addCallback 'draw-circle-add', () =>
            @scope.mode = 'Add Circle'
        ctrl.addCallback 'draw-poly-sub', () =>
            @scope.mode = 'Subtract Shape'
        ctrl.addCallback 'draw-rect-sub', () =>
            @scope.mode = 'Subtract Rectangle'
        ctrl.addCallback 'draw-circle-sub', () =>
            @scope.mode = 'Subtract Circle'

        # Since callbacks are issued in order, setting this
        # apply here at the end means that it  will always
        # happen after the above callbacks (because none of
        # them are asynchronous), so  we don't have to $apply
        # individually in each mode callback
        ctrl.addCallback '*', () =>
            undefined
            # @scope.$apply()
